import {useState} from 'react';
import FullCallendar, {formatDate} from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import {Box, List, ListItem, ListItemText, Typography, useTheme} from '@mui/material';
import Header from '../../components/Header';
import {tokens} from '../../theme';

const Calendar = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [currentEvents, setCurrentEvents] = useState([]);
    const handleDateClick = (selected) => {
        const title = prompt('Enter Event Title');
        const calendarApi = selected.view.calendar;
        calendarApi.unselect();

        if (title) {
            calendarApi.addEvent({
                id: `${selected.dateStr}-${title}`,
                title,
                start: selected.startStr,
                end: selected.endStr,
                allDay: selected.allDay,
            });
        }
        }
        const handleEventClick = (selected) => {
            if (window.confirm('Are you sure you want to delete this event?')) {
                selected.event.remove();
            }
        }
    
    return ( 
        <Box m='20px'>
            <Header title='CALENDAR' subtitle='Calendar Interactive Page' />
            <Box display='flex' justifyContent='space-between'>                {/* Calendar */}
                <Box flex='1 1 20%' background={colors.primary[400]} p='15px' borderRadius='4px'>
                    <Typography variant='h5'>Events</Typography>
                    <List>
                        {currentEvents.map((event) => (
                            <ListItem 
                            key={event.id}
                            sx={{backgroundColor: colors.greenAccent[500],
                            margin: '10px 0',
                            borderRadius: '2px'}}>
                                <ListItemText 
                                primary={event.title}
                                secondary={
                                    <Typography variant='body1'>{formatDate(event.start, {
                                        year: 'numeric',
                                        month: 'short',
                                        day: 'numeric',
                                    })}
                                    </Typography>
                                        }
                                />
                            </ListItem>
                        ))}
                    </List>
                </Box>
                <Box flex='1 1 100%' ml='15px'>
                    <FullCallendar
                    height='75vh'
                    plugins={[
                        dayGridPlugin,
                        timeGridPlugin,
                        interactionPlugin,
                        listPlugin,
                    ]}
                    headerToolbar={{
                        left: 'prev,next today',
                        center: 'title',
                        right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
                    }}
                    initialView='dayGridMonth'
                    editable={true}
                    selectable={true}
                    selectMirror={true}
                    dayMaxEvents={true}
                    select={handleDateClick}
                    eventClick={handleEventClick}
                    eventsSet={(events) => setCurrentEvents(events)}
                    initialEvents={[
                        {id: '1', title: 'Event Example', start: new Date()},
                        {id: '2', title: 'Second Event', start: new Date()},
                        {id: '3', title: 'Third Lucky', start: new Date()},
                        {id: '4', title: 'Four for sure', start: new Date()},
                    ]}
                    />
                </Box>
            </Box>
        </Box>
     );
                    }
export default Calendar;